/* Mission Beard — collection page behaviour.
   1. Intro "Read more" toggle at every width (CSS does the clamping).
   2. Product-card "+ Add" → /cart/add.js → Opus cart drawer.
   Answers, intro copy and FAQ text are always in the DOM; nothing is injected. */
(function () {
  'use strict';
  // The script tag is emitted by more than one section; only wire things up once,
  // otherwise two click handlers toggle each other off (and add to cart twice).
  if (window.__mbPlpInit) return;
  window.__mbPlpInit = true;

  function ready(fn) {
    if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    /* Intro read more */
    document.querySelectorAll('[data-mb-plp-intro]').forEach(function (sec) {
      var btn = sec.querySelector('[data-mb-plp-more]');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var open = sec.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        btn.querySelector('span').textContent = open ? btn.getAttribute('data-less') : btn.getAttribute('data-more');
      });
    });

    /* Card add-to-cart */
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-mb-plp-add]');
      if (!btn || btn.disabled) return;
      e.preventDefault();
      var variantId = btn.getAttribute('data-variant-id');
      if (!variantId) return;
      var labelAdding = btn.getAttribute('data-adding') || 'Adding';
      var labelAdded = btn.getAttribute('data-added') || 'Added';
      var labelIdle = btn.getAttribute('data-idle') || '+ Add';
      btn.disabled = true;
      btn.textContent = labelAdding;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
      })
        .then(function (res) {
          return res.json().then(function (body) {
            if (!res.ok) throw new Error(body.description || body.message || 'Could not add to cart.');
            return body;
          });
        })
        .then(function () {
          btn.disabled = false;
          btn.classList.add('is-added');
          btn.setAttribute('aria-pressed', 'true');
          btn.textContent = labelAdded;
          if (typeof window.opusRefreshCart === 'function') window.opusRefreshCart();
          if (typeof window.opusOpen === 'function') {
            window.opusOpen();
          } else {
            document.dispatchEvent(new CustomEvent('instant:add-to-cart'));
          }
          setTimeout(function () {
            btn.classList.remove('is-added');
            btn.setAttribute('aria-pressed', 'false');
            btn.textContent = labelIdle;
          }, 4000);
        })
        .catch(function (err) {
          btn.disabled = false;
          btn.textContent = labelIdle;
          if (window.console) console.error('[mb-plp]', err);
          window.location.href = btn.getAttribute('data-fallback') || '/cart';
        });
    });
  });
})();
